// extracted by mini-css-extract-plugin
export default {"primary":"#e20714","secondary":"#ff8426","dark":"#000","light":"#fff","breakpointMobile":"1025","carouselLgWidth":"65","carouselXlWidth":"80","carouselSmWidth":"35"};